export default [
  {
    path: '/main/arenaevents',
    meta: {
      tag: 'list_arenaevents',
      name: 'Eventos (Arena)',
      breadcrumb: 'Eventos (Arena)'
    },
    component: () => import(/* webpackChunkName: "arena-event-list" */ '@/views/main/settings/app-frotix-registers/arenaevent/Index.vue'),
    children: [
      {
        path: '',
        name: 'list_arenaevents',
        meta: {
          tag: 'list_arenaevents',
          name: 'Eventos (Arena)',
          menu: 'settings'
        },
        component: () => import(/* webpackChunkName: "arena-event-list" */ '@/views/main/settings/app-frotix-registers/arenaevent/List.vue')
      },
      {
        path: 'add',
        name: 'addarenaevent',
        meta: {
          tag: 'add_arenaevent',
          name: 'Adicionar | Evento (Arena)',
          breadcrumb: 'Adicionar Evento (Arena)',
          menu: 'settings'
        },
        component: () => import(/* webpackChunkName: "arena-event-add" */ '@/views/main/settings/app-frotix-registers/arenaevent/Add.vue')
      },
      {
        path: 'edit/:id',
        name: 'editarenaevent',
        meta: {
          tag: 'edit_arenaevent',
          name: 'Editar | Evento (Arena)',
          breadcrumb: 'Editar Evento (Arena)',
          menu: 'settings'
        },
        component: () => import(/* webpackChunkName: "arena-event-edit" */ '@/views/main/settings/app-frotix-registers/arenaevent/Edit.vue')
      }
    ]
  }
]
